import { initialState } from '..';
import type { BetSlipState } from '../types';

const receiptClosed = (state: BetSlipState): BetSlipState => ({
  ...state,
  receipt: initialState.receipt
});

export default receiptClosed;
